import {uniqueId} from 'lodash';
import TableModel from './table';

export default class SchemaModel {
    datasource = null;
    _tablesMap = {};

    constructor(schemaData, datasource) {
        Object.assign(this, schemaData);
        this.id = this.id || uniqueId('schema');
        if (datasource) {
            this.datasource = datasource;
        }
        this.tables = [];
        for (const table of schemaData.tables) {
            const processedTable = new TableModel(table, this);
            this.tables.push(processedTable);
            this._tablesMap[processedTable.name] = processedTable;
        }
        this.tables.sort((a, b) => a.name > b.name ? 1 : -1);
    }

    getTable(tableName) {
        return this._tablesMap[tableName];
    }

    getColumn(fullColumnName) {
        let [schemaName, tableName, columnName] = fullColumnName.split('.');
        if (!columnName) {
            columnName = tableName;
            tableName = schemaName;
        }
        const table = this.getTable(tableName);
        return table.getColumnByName(columnName);
    }

    filter(searchQuery) {
        const filteredSchema = new SchemaModel(this);
        filteredSchema.tables = filteredSchema.tables
            .map(table => table.filter(searchQuery))
            .filter(({columns}) => columns.length);
        return filteredSchema;
    }

    get label() {
        return this.title_name || this.name;
    }
}
